/**
 * OfflineBanner - Shows when app is in offline/degraded mode
 */

import { FC, useEffect } from 'react';
import { Alert, Slide } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { useIsOffline, useApp } from '../../store';

export const OfflineBanner: FC = () => {
  const isOffline = useIsOffline();
  const { dispatch } = useApp();

  useEffect(() => {
    const handleOnline = () => {
      dispatch({ type: 'SET_OFFLINE', payload: false });
    };

    const handleOffline = () => {
      dispatch({ type: 'SET_OFFLINE', payload: true });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check initial state
    if (!navigator.onLine) {
      dispatch({ type: 'SET_OFFLINE', payload: true });
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [dispatch]);

  return (
    <Slide direction="down" in={isOffline} mountOnEnter unmountOnExit>
      <Alert
        severity="warning"
        icon={<WifiOffIcon />}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          borderRadius: 0,
          justifyContent: 'center',
        }}
        role="status"
        aria-live="polite"
      >
        You&apos;re offline. Some features may not be available.
      </Alert>
    </Slide>
  );
};
